






















































































































































import {defineComponent, reactive} from '@vue/composition-api'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default defineComponent({
  components: {
    VuePerfectScrollbar,
  },
  setup() {
    const state = reactive({
      open: false,
      activeTab: 0,
      pinned: true,
    })

    const togglePinned = () => {
      state.pinned = !state.pinned
    }

    const open = () => {
      state.open = true
    }

    const close = () => {
      state.open = false
    }
    return {state, open, close, togglePinned}
  }
})
